<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive>
        <router-view />
      </keep-alive>
    </transition>
    <div id="el-main-footer">
      <com-footer bgColor="white"></com-footer>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    cachedViews () {
      return this.$store.state.tagsView.cachedViews
    },
    key () {
      return this.$route.path
    }
  },
  components: {
    'com-footer': resolve => require(['@/components/common/Footer.vue'], resolve)
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  height: calc(100vh - 70px);
  width: 100%;
  position: relative;
  overflow-y: auto;
  background: #f5f5f5;
}
#el-main-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  border-top:1px solid #dddddd;
  z-index: 99;
}

.fixed-header+.app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
  }

  .fixed-header+.app-main {
    padding-top: 84px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/AppMain.vue